export default {
  forgot_password: { id: 'forgot_password' },
  back: { id: 'back' },
  back_to_signin: { id: 'back_to_signin' },
}
